// Copyright (c) 2016 Deere & Company

import ClaimErrorField, {getDefaultState as getDefaultClaimErrorFieldState} from './claim-error-field';
import KeyValuePair, {getDefaultState as getKeyValueDefaultState} from './key-value-pair';
import t from 'tcomb';

const ClaimVsrMessage = t.struct({
    errorField: t.maybe(ClaimErrorField),
    message: t.String,
    messageId: t.String,
    messageNumber: t.String,
    type: KeyValuePair
}, {
    name: 'ClaimVsrMessage',
    strict: true
});

export const getDefaultState = () => new ClaimVsrMessage({
    errorField: getDefaultClaimErrorFieldState(),
    message: '',
    messageId: '',
    messageNumber: '',
    type: getKeyValueDefaultState()
});

export default ClaimVsrMessage;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/claim-vsr-message.js